import Immutable from 'immutable';

import { PAYMENT_PLAN_TYPES } from 'constants/payment';

export function getHotelPriceObject(bookState) {
  const roomSelectionIds = bookState.getIn(['booking_info', 'selection', 'room_selected'], Immutable.List());
  const hotelPrice = {
    webPrice: 0,
    retailPrice: 0,
    nettPrice: 0,
  };

  roomSelectionIds.forEach((roomSelectionId) => {
    const pricing = bookState.getIn(['entities', 'roomRestrictions', `${roomSelectionId}`, 'pricing']);

    hotelPrice.webPrice += pricing.get('webPrice');
    hotelPrice.retailPrice += pricing.get('retailPrice');
    hotelPrice.nettPrice += pricing.get('nettPrice');
  });

  return hotelPrice;
}

export function paymentPlanPriorityScore(bookState, planId) {
  const paymentPlan = bookState.getIn(['entities', 'paymentPlans', `${planId}`]);
  const isAvailable =  paymentPlan.get('availability') === 'AVAILABLE';
  const sortOrder = [
    PAYMENT_PLAN_TYPES.SPREAD_THE_COST,
    PAYMENT_PLAN_TYPES.LOW_DEPOSIT,
    PAYMENT_PLAN_TYPES.STANDARD_DEPOSIT,
    PAYMENT_PLAN_TYPES.PAY_IN_FULL,
  ];
  const index = sortOrder.indexOf(planId);
  let score = index === -1 ? sortOrder.length + 1 : index;

  if (!isAvailable) {
    score += sortOrder.length;
  }

  return score;
}

export function getFlightMealsPrice(bookState) {
  const selectedFlightMealIds = bookState.getIn(['booking_info', 'selection', 'extras', 'flightMeals']) || Immutable.List();
  const meals = bookState.getIn(['entities', 'flightMeals']) || Immutable.List();
  let total = 0;

  selectedFlightMealIds.map((id) => {
    total += meals.getIn([`${id}`, 'pricing', 'webPrice'], 0);
  });

  return total;
}

export function findFlightSeat(flightDirection, rowNumber, seatNumber) {
  let flightSeat;

  const flightRow = flightDirection.getIn(['flightSeatMap', 'flightRows'], Immutable.List()).find(row => row.get('rowNumber') === rowNumber);
  if (flightRow) {
    flightSeat = flightRow.get('flightSeats').find(seat => seat.get('seatNumber') === seatNumber);
  }

  return flightSeat;
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/bookStateUtils.js
 **/